import React from 'react'

export default function Message({ className }) {
  return (
    <svg viewBox="0 0 20 20" className={className}>
      <path
        fillRule="evenodd"
        fill="currentColor"
        d="M17.917 14.103l.971 2.742c.211.595.122 1.289-.322 1.738a1.731 1.731 0 01-.445.326c-.372.19-.816.182-1.214.057l-2.979-.94-.001-.006a9.474 9.474 0 01-4.393 1.079c-5.267 0-9.536-4.275-9.536-9.55C-.002 4.275 4.267 0 9.534 0 14.8 0 19.07 4.275 19.07 9.549a9.513 9.513 0 01-1.153 4.554zm-6.149-2.029V3.195L7.382 5.021v2.73l2.962-1.233v3.577a2.363 2.363 0 00-1.184-.03c-1.441.325-2.609 1.758-2.609 3.201s1.168 2.35 2.609 2.025c1.382-.311 2.501-1.642 2.592-3.023h.016v-.161l.001-.017-.001-.016z"
      />
    </svg>
  )
}
